import React, { createContext } from 'react';
import { AxiosResponse } from 'axios';

import { DynamicWorkspaceResponse, HTTPError } from '@/api/types';

type PowerBIContextType = {
  reportList: AxiosResponse<DynamicWorkspaceResponse>;
  isLoadingReportList: boolean;
  reportListError: HTTPError;
};

export const PowerBIContext = createContext<PowerBIContextType>(null);

export const PowerBIProvider = ({
  children,
  reportList,
  isLoadingReportList,
  reportListError,
}: {
  children: React.ReactNode;
  reportList: AxiosResponse<DynamicWorkspaceResponse>;
  isLoadingReportList: boolean;
  reportListError: HTTPError;
}) => {
  return (
    <PowerBIContext.Provider value={{ reportList, isLoadingReportList, reportListError }}>
      {children}
    </PowerBIContext.Provider>
  );
};

export const usePowerBIContext = () => {
  const powerBIContext = React.useContext(PowerBIContext);
  if (powerBIContext === undefined) {
    throw new Error('useOnboardingContext must be inside a PowerBIContext');
  }
  return powerBIContext;
};
